export enum BankRelinkModalVariant {
  ContributionFailed = "ContributionFailed",
  RelinkFundingSource = "RelinkFundingSource",
  ResumeContributions = "ResumeContributions",
  AccountPaused = "AccountPaused",
}

export type BankRelinkModalProps = {
  variant: BankRelinkModalVariant;
};
